<script setup lang="ts"></script>

<template>
  <icon name="lucide:cloud-download" />
</template>

<style scoped></style>
